import { render, staticRenderFns } from "./LevelConf.vue?vue&type=template&id=51e0806b"
import script from "./LevelConf.vue?vue&type=script&lang=js"
export * from "./LevelConf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports